import React from 'react';

import { setClassNameInDefns } from '../../common/definitionHelper';
import { makeStyles, DialogTitle, DialogContent, DialogActions, Dialog, DialogContentText } from '@material-ui/core';

import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdButton from '../../common/elemental/AfitdButton';

const useStyles = makeStyles(theme => ({
    noButton: { marginRight: 16 },
    title: { fontWeight: 'bold' },
    // message: { color: 'rgba(17, 30, 20, 0.4)' },
}));

const getDefns = params => {
    const { props, classes } = params;
    const { open, onClose, onConfirm, color } = props;

    const defns = {
        root: { open, maxWidth: 'md', disableBackdropClick: true, disableEscapeKeyDown: true },
        noButton: { onClick: onClose },
        yesButton: { onClick: onConfirm, color: color || 'secondary' },
        message: { variant: 'body1' },
    };

    setClassNameInDefns(defns, classes);
    return defns;
};

const ConfirmationDialog = props => {
    const classes = useStyles();
    const { title, message, confirmLabel } = props;
    const defns = getDefns({ props, classes });

    return (
        <>
            <Dialog {...defns.root}>
                <DialogTitle>
                    <div {...defns.title}>{title}</div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <AfitdTypography {...defns.message}>{message}</AfitdTypography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <AfitdButton {...defns.noButton}>No</AfitdButton>
                    <AfitdButton {...defns.yesButton}>{confirmLabel || 'Yes'}</AfitdButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ConfirmationDialog;
